import { render, staticRenderFns } from "./DivergentPage.vue?vue&type=template&id=189ff7e3&scoped=true"
import script from "./DivergentPage.vue?vue&type=script&lang=js"
export * from "./DivergentPage.vue?vue&type=script&lang=js"
import style0 from "./DivergentPage.vue?vue&type=style&index=0&id=189ff7e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189ff7e3",
  null
  
)

export default component.exports